import Rails from '@rails/ujs';
import LocalTime from 'local-time';

import { attachWorkspaceIdToRequests } from './lib/api';

import './controllers';

attachWorkspaceIdToRequests();

Rails.start();

LocalTime.start();
